import { RouteProp, useRoute } from '@react-navigation/native';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { SignedInRootStackParamList } from '../../../../../../../routes/types';
import { reportTypeOptionState } from '../../../../../../../store/customerDetail/reports/atom';
import { QueryPropsType } from '../Header';

import { AnnualIncomeReportsFilter } from './annualIncome';
import { BrokerageReportsFilter } from './brokerage';
import { ComplementaryReportsFilter } from './complementary';

type ReportFitlerProps = {
  incomeTaxTypeReports: QueryPropsType;
  incomeTaxBaseYearReports: QueryPropsType;
  accountNumber: number;
  cpfCnpj: string;
};

export interface ReportFilterTypeProps extends ReportFitlerProps {}

export const ReportsFilter: React.FC = () => {
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'ReportsFilter'>>();

  const reportTypeOption = useRecoilValue(reportTypeOptionState);

  if (reportTypeOption === 'annual-income-report') {
    return <AnnualIncomeReportsFilter {...params} />;
  }

  if (reportTypeOption === 'complementary') {
    return <ComplementaryReportsFilter {...params} />;
  }

  return <BrokerageReportsFilter {...params} />;
};
